import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private toastr = inject(ToastrService);
  private translate = inject(TranslateService);

  success(messageKey: string, titleKey?: string): void {
    const message = this.translate.instant(messageKey);
    const title = titleKey ? this.translate.instant(titleKey) : undefined;
    this.toastr.success(message, title);
  }

  error(messageKey: string, titleKey?: string): void {
    const message = this.translate.instant(messageKey);
    const title = titleKey ? this.translate.instant(titleKey) : undefined;
    this.toastr.error(message, title);
  }

  warning(messageKey: string, titleKey?: string): void {
    const message = this.translate.instant(messageKey);
    const title = titleKey ? this.translate.instant(titleKey) : undefined;
    this.toastr.warning(message, title);
  }

  info(messageKey: string, titleKey?: string): void {
    const message = this.translate.instant(messageKey);
    const title = titleKey ? this.translate.instant(titleKey) : undefined;
    this.toastr.info(message, title);
  }

  infoRaw(message: string, title?: string): void {
    this.toastr.info(message, title);
  }

  successRaw(message: string, title?: string): void {
    this.toastr.success(message, title);
  }

  errorRaw(message: string, title?: string): void {
    this.toastr.error(message, title);
  }
}
